var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilters = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.124 23.008A4.002 4.002 0 0 1 16 24a4 4 0 0 1-7.876.992Q8.064 25 8 25H2a1 1 0 1 1 0-2h6q.063 0 .124.008M24.874 15H30a1 1 0 1 1 0 2h-5.126A4.002 4.002 0 0 1 17 16a4 4 0 0 1 7.874-1M11 7h19a1 1 0 1 1 0 2H11zm-9 8h13v2H2a1 1 0 1 1 0-2m16 8h12a1 1 0 1 1 0 2H18zM5 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4m16 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-9 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
})));
export default SvgFilters;